"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var GetCursorPosition = function GetCursorPosition(a) {
  var b = a.event,
      c = a.element;
  if (!window || !document) throw new Error("[Cursor-pointer] window or document not defined");

  if (!b) {
    var d = window;
    b = d.event;
  }

  var e = 0,
      f = 0;
  if (b.pageX || b.pageY ? (e = b.pageX, f = b.pageY) : b.clientX || b.clientY ? (e = b.clientX, f = b.clientY) : b.touches && (e = b.touches[0].clientX, f = b.touches[0].clientY), document && document.body && document.documentElement && (e += document.body.scrollLeft + document.documentElement.scrollLeft, f += document.body.scrollTop + document.documentElement.scrollTop), c && (e -= c.offsetLeft, f -= c.offsetTop, c.offsetParent)) for (var g = c.offsetParent; g && (e -= g.offsetLeft, f -= g.offsetTop, !!g.offsetParent);) {
    g = g.offsetParent;
  }
  return {
    x: e,
    y: f
  };
},
    _default = GetCursorPosition;

exports.default = _default;